import MyInfo from "./MyInfo";
import Footer from "./Footer";
import Navbar from "./Navbar";
import pdf from "../Documents/CV_Neupane.pdf";
import "../Styles/Home.css";
import "../Styles/CV.css";
import "../Styles/Research.css";
import "../Styles/Experience.css";

const Home = () => {
  return (
    <div className="home-container">
      <Navbar />
      <div className="main-content">
        {/* Hero Section */}
        <section id="home" className="section">
          <MyInfo />
        </section>

        {/* About/CV Section */}
        <section id="about" className="section">
          <div className="cv-container">
            <div className="research-section">
              <h1 className="section-title">About</h1>
            </div>
            
            <div className="cv-content">
              <div className="cv-section">
                <div className="cv-personal-info">
                  <h1 className="cv-name">Tank Prasad Neupane</h1>
                  <div className="cv-contact">
                    <div className="contact-line">
                      <span className="label">Institution:</span> Jindal Global Law School
                      <span className="label">Email:</span> tankp.neupane@jgu.edu.in
                    </div>
                    <div className="contact-line">
                      <span className="label">University:</span> O. P. Jindal Global University
                      <span className="label">Phone:</span> +91-7419614691
                    </div>
                    <div className="contact-line">
                      <span className="label">Location:</span> Sonipat, India
                    </div>
                  </div>
                </div>
              </div>

              <div className="cv-section">
                <h2 className="cv-section-title">Education</h2>
                <div className="cv-item">
                  <span className="cv-degree">Ph.D. (Marketing)</span> O. P. Jindal Global University <span className="cv-year">2023-</span>
                </div>
                <div className="cv-item">
                  <span className="cv-degree">M.Phil. (Marketing)</span> Kathmandu University, Nepal <span className="cv-year">2019</span>
                </div>
                <div className="cv-item">
                  <span className="cv-degree">M.B.A. (Marketing)</span> Sikkim Manipal University, India <span className="cv-year">2014</span>
                </div>
                <div className="cv-item">
                  <span className="cv-degree">MSc (Physics)</span> Tribhuvan University, Nepal <span className="cv-year">2008</span>
                </div>
                <div className="cv-item">
                  <span className="cv-degree">BSc (Physics)</span> Tribhuvan University, Nepal <span className="cv-year">2003</span>
                </div>
              </div>

              <div className="cv-section">
                <h2 className="cv-section-title">Employment</h2>
                <div className="employment-entry">
                  <div className="job-info">
                    <div className="job-title">Lecturer Marketing</div>
                    <div className="institution">Jindal Global Law School</div>
                    <div className="institution">O. P. Jindal Global University</div>
                    <div className="location">Sonipat, India</div>
                  </div>
                  <div className="year">2022</div>
                </div>
                
                <div className="employment-entry">
                  <div className="job-info">
                    <div className="job-title">Visiting Faculty Finance & Marketing Department</div>
                    <div className="institution">Lumbini Banijya Campus</div>
                    <div className="institution">Tribhuvan University, Nepal</div>
                  </div>
                  <div className="year">2018-2022</div>
                </div>
                
                <div className="employment-entry">
                  <div className="job-info">
                    <div className="job-title">Visiting Faculty Finance & Operations Research</div>
                    <div className="institution">Little Angels' College of Management</div>
                    <div className="institution">Kathmandu University, Nepal</div>
                  </div>
                  <div className="year">2015 – 2018</div>
                </div>
                
                <div className="employment-entry">
                  <div className="job-info">
                    <div className="job-title">Visiting Faculty Finance & Marketing Department</div>
                    <div className="institution">Sky International College</div>
                    <div className="institution">Sikkim Manipal University, India</div>
                  </div>
                  <div className="year">2014 – 2015</div>
                </div>
                
                <div className="employment-entry">
                  <div className="job-info">
                    <div className="job-title">Lecturer Physics Department</div>
                    <div className="institution">New Horizon Institute, Nepal</div>
                  </div>
                  <div className="year">2009 – 2012</div>
                </div>
              </div>
            </div>
            
            <div className="cv-pdf-section">
              <h2 className="cv-section-title">Complete CV Document</h2>
              <div className="pdf-container">
                <object
                  width="100%"
                  height="800px"
                  type="application/pdf"
                  data={pdf}
                  aria-label="Tank Prasad Neupane - Curriculum Vitae PDF"
                >
                  <p>
                    Your browser does not support PDFs. 
                    <a href={pdf} download="Tank_Prasad_Neupane_CV.pdf" className="pdf-fallback-link">
                      Download the PDF instead
                    </a>
                  </p>
                </object>
              </div>
            </div>
          </div>
        </section>

        {/* Research Section */}
        <section id="research" className="section">
          <div className="page-content">
            <div className="research-container">
              <div className="research-section">
                <h2 className="section-title">Research Portfolio</h2>
              </div>

              <div className="research-section">
                <h3 className="section-title">Area of Interest</h3>
                <p className="research-interest">Behavioral Economics/Consumer Behavior</p>
              </div>

              <div className="research-section">
                <h3 className="section-title">Peer Reviewed Publications</h3>
                <div className="publications-list">
                  <div className="publication-item">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.nowpublishers.com/article/Details/RBE-0126"
                      className="publication-link"
                    >
                      Neupane, T.P. (2020). Is Individualism Fatal in Pandemic? Review of Behavioral Economics, 7, 1-16. U.S.A.: Now Publisher. "Lead Paper," (Indexed in ABDC- B, ABS-2).
                    </a>
                  </div>
                  
                  <div className="publication-item">
                    <span className="publication-text">
                      Neupane, T.P. (2023). Evaluating Smart Agricultural Village Program: A Mixed Method Approach. Agricultural Economics Review (Indexed in ABDC- C, SCOPUS- Indexed).
                    </span>
                  </div>
                  
                  <div className="publication-item">
                    <span className="publication-text">
                      Neupane, T.P. (2019). Effect of Remittance Inflows on Urban Slums. The Lumbini Journal of Business and Economics 1(1), 17-24. Nepal: Lumbini Banijya Campus.
                    </span>
                  </div>
                  
                  <div className="publication-item">
                    <span className="publication-text">
                      Timilsena, R., Chaudhary, L. and Neupane, T.P. (2021). Public Service Motivation and Satisfaction of Nurses in Butwal City in COVID-19 Pandemic. The Lumbini Journal of Business and Economics 7(1), 11-23. Nepal: Lumbini Banijya Campus.
                    </span>
                  </div>
                </div>
              </div>

              <div className="research-section">
                <h3 className="section-title">Grants and Policy-Related Contribution</h3>
                <div className="grants-list">
                  <div className="grant-item">
                    <div className="grant-title">Feasibility Study to Establish Province University in Province No. 5 (2020)</div>
                    <div className="grant-details">
                      <span className="role">Team Member</span><br />
                      Report Submitted to Ministry of Social Development, Province No 5, Butwal, Nepal.<br />
                      <span className="grant-amount">[Grants: NRs. 1.49 million]</span>
                    </div>
                  </div>
                  
                  <div className="grant-item">
                    <div className="grant-title">Impact Evaluation of SMART Agricultural Village Program (2021)</div>
                    <div className="grant-details">
                      <span className="role">Principal Investigator</span><br />
                      Report Submitted to Provincial Planning Commission, Lumbini Province, Nepal.<br />
                      <span className="grant-amount">[Grants: NRs. 0.5 million]</span>
                    </div>
                  </div>
                  
                  <div className="grant-item">
                    <div className="grant-title">Skill Mapping and Survey Program of Karnali Province (2021)</div>
                    <div className="grant-details">
                      <span className="role">Principal Investigator</span><br />
                      Inception Report Submitted to Ministry of Education, Science and Technology Singhadarbar Kathmandu.<br />
                      <span className="grant-amount">[Grants: NRs. 1.5 million]</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="research-section">
                <h3 className="section-title">Seminar Presentations</h3>
                <div className="seminars-list">
                  <div className="seminar-item">
                    <div className="seminar-title">Effect of Remittance Inflows on Urban Slums</div>
                    <div className="seminar-details">
                      International Seminar on Redefining Management Education in Nepal. Lumbini Banijya Campus, Butwal.
                    </div>
                  </div>
                  
                  <div className="seminar-item">
                    <div className="seminar-title">Public Service Motivation and Satisfaction of Nurses in Butwal City in COVID-19 Pandemic</div>
                    <div className="seminar-details">
                      Conference-themed Paradigm-Shifts in Business Management, Social Innovation, and Information Science. Lumbini Banijay Campus, Nepal.
                    </div>
                  </div>
                  
                  <div className="seminar-item">
                    <div className="seminar-title">Social, Economic and Environmental Sustainability: Exploring Gap in School Level Curriculum in India</div>
                    <div className="seminar-details">
                      I.C.S.S.R. sponsored workshop on "Digitization and Circular Economy Practices in India: A Drive for Swachh Bharat Abhiyan and Digital India," on 16 & 17 December 2022, O P Jindal Global University, India.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Experience Section */}
        <section id="experience" className="section">
          <div className="experience-container">
            <div className="experience-section">
              <h2 className="section-title">Professional Experience</h2>
            </div>

            <div className="experience-section">
              <h3 className="section-title">Teaching Experience (2014 – Present, BBA and MBA)</h3>
              <div className="teaching-courses">
                <div className="course-category">
                  <h4 className="category-title">MBA Courses</h4>
                  <ul className="courses-list">
                    <li>Marketing Management</li>
                    <li>Project Appraisal and Valuation</li>
                    <li>Corporate Finance</li>
                    <li>Consumer Behaviour</li>
                    <li>Operation Research</li>
                  </ul>
                </div>
                
                <div className="course-category">
                  <h4 className="category-title">BBA Courses</h4>
                  <ul className="courses-list">
                    <li>Capital Structure</li>
                    <li>Service Operations Management</li>
                    <li>Data Analysis and Modelling</li>
                    <li>Quantitative Techniques for Management</li>
                    <li>Principles of Marketing</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="experience-section">
              <h3 className="section-title">Independently Developed and Floated Courses</h3>
              <div className="developed-courses">
                <div className="course-item">
                  <div className="course-name">Industrial and Organizational Psychology of Family Business</div>
                  <div className="course-details">
                    An elective offered in the 2022 session to undergraduate and graduate students at O. P. Jindal Global University, India.
                  </div>
                </div>
                
                <div className="course-item">
                  <div className="course-name">Service Design Concepts for Law Students</div>
                  <div className="course-details">
                    An elective offered in the 2022 session to undergraduate and graduate students at O. P. Jindal Global University, India.
                  </div>
                </div>
                
                <div className="course-item">
                  <div className="course-name">Business Analytics for B.B.A. Students</div>
                  <div className="course-details">
                    A compulsory course offered to BBA-FA students at Lumbini Banijay Campus, Tribhuvan University, Nepal.
                  </div>
                </div>
              </div>
            </div>

            <div className="experience-section">
              <h3 className="section-title">Leadership Experience</h3>
              <div className="leadership-list">
                <div className="leadership-item">
                  <div className="position">Principal</div>
                  <div className="organization">Eden English Boarding High School</div>
                  <div className="duration">(4 years)</div>
                </div>
                
                <div className="leadership-item">
                  <div className="position">Director</div>
                  <div className="organization">T. & T. Consulting and Research Services</div>
                  <div className="duration">(3 years)</div>
                </div>
              </div>
            </div>

            <div className="experience-section">
              <h3 className="section-title">Reviewer's Experience</h3>
              <div className="reviewer-list">
                <div className="journal-item">
                  <strong>Review of Behavioural Economics:</strong> USA – An ABDC 'B' Category Journal
                </div>
                <div className="journal-item">
                  <strong>Agricultural Economics Review-</strong> An ABDC 'C' Category Journal
                </div>
                <div className="journal-item">
                  <strong>EuroMed Journal of Business-</strong> Emerald Publishing a Scimago Q1 Journal
                </div>
                <div className="journal-item">
                  <strong>Journal of Business and Management Research-</strong> double-masked peer-reviewed scholarly biannual journal published by the School of Management, Kathmandu University, Nepal
                </div>
                <div className="journal-item">
                  <strong>The Lumbini Journal of Business and Economics:</strong> Nepal
                </div>
              </div>
            </div>

            <div className="experience-section">
              <h3 className="section-title">Languages</h3>
              <div className="languages-list">
                <div className="language-item">English</div>
                <div className="language-item">Nepali</div>
                <div className="language-item">Hindi</div>
              </div>
            </div>

            <div className="experience-section">
              <h3 className="section-title">References</h3>
              <div className="references-list">
                <div className="reference-item">
                  <div className="reference-name">Devi Bedari, PhD</div>
                  <div className="reference-details">
                    Professor & Dean, Economics<br />
                    School of Management<br />
                    Kathmandu University, Nepal<br />
                    <a href="mailto:devi@kusom.edu.np" className="email-link">devi@kusom.edu.np</a>
                  </div>
                </div>
                
                <div className="reference-item">
                  <div className="reference-name">Biswonath Poudel, PhD</div>
                  <div className="reference-details">
                    Professor, Economics<br />
                    School of Management<br />
                    Kathmandu University, Nepal<br />
                    <a href="mailto:biswo@kusom.edu.np" className="email-link">biswo@kusom.edu.np</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};
export default Home;
